import rawAxios from 'axios';

import axios from '@/core/services/axios';

/**
 * Клиент служебного API ShbDeployer: состояние компонентов и диагностика.
 * Используется страницами «Состояние системы», «Диагностика», «Техническая поддержка».
 *
 * Методы под `/api` выполняются настроенным экземпляром axios: он задаёт базовый
 * адрес `api` и подставляет токен доступа в заголовок Authorization. Пробы
 * `/health` и `/ready` расположены вне `/api` и аутентификации не требуют,
 * поэтому выполняются экземпляром из пакета.
 */
const BASE = '/system';

export async function getSystemStatus() {
  const { data } = await axios.get(`${BASE}/status`);
  return data;
}

export async function getSystemDiagnostics() {
  const { data } = await axios.get(`${BASE}/diagnostics`);
  return data;
}

/** Liveness-проверка без аутентификации (для страницы состояния). */
export async function getHealth() {
  const { data } = await rawAxios.get('health');
  return data;
}

/** Readiness-проверка без аутентификации. */
export async function getReadiness() {
  try {
    const { data } = await rawAxios.get('ready');
    return { ready: true, ...data };
  } catch (err) {
    const data = err.response && err.response.data ? err.response.data : {};
    return { ready: false, ...data };
  }
}

/*
 * Имя сервиса — ShbSystemService, а не SystemService: последнее уже занято
 * сервисом Docker (app/docker/services/systemService.js). Инжектор AngularJS
 * разрешает зависимости по имени глобально, поэтому одноимённая регистрация
 * перекрывала этот сервис и страницы «Состояние системы» и «Диагностика»
 * не получали данных.
 */
/* @ngInject */
export function ShbSystemService($async) {
  return {
    status: () => $async(getSystemStatus),
    diagnostics: () => $async(getSystemDiagnostics),
    health: () => $async(getHealth),
    readiness: () => $async(getReadiness),
  };
}
